export default "/images/vendor/flag-icon-css/flags/4x3/bt.svg?eed19cbfd0dc809d6886614fe43413d5";